/**
 * This is a temporary utility file to help examine the format of cookies
 * from code-garden so we can ensure our implementation matches exactly.
 */

export function checkCookieFormat() {
  // Log all cookies
  // console.log('All cookies:', document.cookie);

  // Try to find Supabase cookies
  const cookies = document.cookie.split(';').map(cookie => cookie.trim());
  
  // Log which cookies start with "sb-"
  const supaCookies = cookies.filter(cookie => cookie.startsWith('sb-'));
  // console.log('Supabase cookies:', supaCookies);

  // For each Supabase cookie, try to parse and log its structure
  supaCookies.forEach(cookie => {
    const [name, value] = cookie.split('=');
    // console.log(`Cookie name: ${name}`);
    
    try {
      // Decode the URL-encoded value
      const decodedValue = decodeURIComponent(value);
      // console.log(`Decoded cookie value:`, decodedValue);
      
      // Try to parse as JSON if it's in JSON format
      try {
        const parsedValue = JSON.parse(decodedValue);
        // console.log(`Parsed cookie value (JSON):`, parsedValue);
        // console.log(`Cookie type:`, typeof parsedValue);
      } catch {
        // Not JSON
        // console.log(`Cookie is not in JSON format. Value type:`, typeof decodedValue);
      }
    } catch (e) {
      console.error(`Error decoding cookie:`, e);
    }
  });
}